import React, { useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import LayoutContainer from 'components/Common/LayoutContainer'
import OfferPage from 'components/OfferPage'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import { useAppDispatch } from 'hooks/reduxHooks'
import { fetchBestOfferForProperty, fetchOfferById } from 'actions/OfferActions'
import { connect } from 'react-redux'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'components/Luxkit/Typography/BodyText'
import HttpStatus from 'components/Common/HttpStatus'
import OfferPageHeadData from 'components/OfferPage/OfferPageHeadData'
import { isBedbankOffer, isLEHotel } from 'lib/offer/offerTypes'
import RedirectWithStatus from 'components/Common/RedirectWithStatus'

export function getPropertyIdFromURL(propertyNameAndId: string) {
  const position = Math.max(propertyNameAndId.lastIndexOf('le:'), propertyNameAndId.lastIndexOf('bedbank:'))
  return propertyNameAndId.slice(position)
}

interface Props extends RouteComponentProps<{ propertyNameAndId: string }> {
  bestOfferId?: string
  fetching: boolean
  propertyId: string
  offer: App.Offer | App.BedbankOffer | undefined
  currentRegionCode: string
}

function PropertyPage(props: Props) {
  const { bestOfferId, fetching, propertyId, offer, currentRegionCode } = props
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchBestOfferForProperty(propertyId))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId])

  useEffect(() => {
    if (bestOfferId) {
      dispatch(fetchOfferById(bestOfferId))
    }
  }, [bestOfferId, dispatch])

  if (isBedbankOffer(offer)) {
    return <RedirectWithStatus code={301} to={`/${currentRegionCode.toLowerCase()}/partner/${offer.slug}/${offer.id}`} />
  }

  if (fetching) {
    return <LayoutContainer>
      <LoadingIndicator inline>
        <BodyText variant="large" weight="bold">Searching for offers</BodyText>
      </LoadingIndicator>
    </LayoutContainer>
  } else if (!bestOfferId) {
    return <HttpStatus code={404}>
      <Error404PageWithOffers />
    </HttpStatus>
  }

  return <>
    {offer && isLEHotel(offer) && <OfferPageHeadData offer={offer} />}
    <OfferPage propertyPageOfferId={bestOfferId} />
  </>
}

function mapStateToProps(state: App.State, ownProps: Partial<Props>) {
  const propertyId = getPropertyIdFromURL(ownProps.match?.params.propertyNameAndId ?? '')
  const bestOfferState = state.offer.bestPropertyOffer[propertyId]
  const offer = bestOfferState?.offerId ? state.offer.offers[bestOfferState?.offerId] : undefined

  return {
    propertyId,
    bestOfferId: bestOfferState?.offerId,
    fetching: bestOfferState?.fetching ?? true,
    offer,
    currentRegionCode: state.geo.currentRegionCode,
  }
}

export default connect(mapStateToProps)(withRouter(PropertyPage))
